/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { VoucherConsegnaComunicazioneDTO } from '../model/models';
import { VoucherConsegnaSummaryDTO } from '../model/models';
import { VoucherDTO } from '../model/models';
import { VoucherEmissioneSummaryDTO } from '../model/models';
import { VoucherProrogaAnteprimaDTO } from '../model/models';
import { VoucherProrogaBandoForm } from '../model/models';
import { VoucherProrogaEsitoDTO } from '../model/models';
import { VoucherProrogaForm } from '../model/models';
import { VoucherRevocaAnnullamentoForm } from '../model/models';
import { VoucherRevocaForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AnnullaRevocaVoucherRequestParams {
    idTipoPratica: string;
    idVoucher: string;
    voucherRevocaAnnullamentoForm: VoucherRevocaAnnullamentoForm;
}

export interface AnteprimaProrogaVoucherBandoRequestParams {
    idTipoPratica: string;
    voucherProrogaBandoForm: VoucherProrogaBandoForm;
}

export interface ComunicazioneConsegnaVoucherRequestParams {
    idTipoPratica: string;
}

export interface ConsegnaVoucherRequestParams {
    idTipoPratica: string;
}

export interface DettaglioVoucherRequestParams {
    idTipoPratica: string;
    idVoucher: string;
}

export interface DownloadVoucherPdfRequestParams {
    idTipoPratica: string;
    idVoucher: string;
}

export interface GeneraVoucherRequestParams {
    idTipoPratica: string;
}

export interface ListaVoucherRequestParams {
    idTipoPratica: string;
}

export interface ProrogaVoucherRequestParams {
    idTipoPratica: string;
    idVoucher: string;
    voucherProrogaForm: VoucherProrogaForm;
}

export interface ProrogaVoucherBandoRequestParams {
    idTipoPratica: string;
    voucherProrogaBandoForm: VoucherProrogaBandoForm;
}

export interface RevocaVoucherRequestParams {
    idTipoPratica: string;
    idVoucher: string;
    voucherRevocaForm: VoucherRevocaForm;
}


export interface VoucherControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Annulla la revoca attiva di un voucher (D-61), solo SUPERADMIN
     * Ammesso solo per le revoche SOLO_NON_SPESO e BLOCCA_E_REGISTRA (BLOCCA_E_STORNA -&gt; 422): il voucher torna allo stato precedente la revoca, la revoca resta nello storico come annullata e il voucher si puo\&#39; revocare di nuovo. Motivo obbligatorio e version del voucher (stale -&gt; 409). Dopo l\&#39;annullamento parte l\&#39;evento VOUCHER_RIATTIVATO (non per i voucher ASSEGNATO).
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/annulla-revoca
* @param requestParameters
     */
    annullaRevocaVoucher(requestParameters: AnnullaRevocaVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherDTO>;

    /**
     * Anteprima della proroga di bando (nessuna scrittura)
     * Stessi parametri della proroga di bando; il motivo non e\&#39; richiesto. Ritorna quanti voucher verrebbero prorogati e quanti saltati, con la scadenza minima e massima risultanti.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/proroga/anteprima
* @param requestParameters
     */
    anteprimaProrogaVoucherBando(requestParameters: AnteprimaProrogaVoucherBandoRequestParams, extraHttpRequestParams?: any): Observable<VoucherProrogaAnteprimaDTO>;

    /**
     * Canali su cui partirà la comunicazione al cittadino alla consegna dei voucher
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/consegna/comunicazione
* @param requestParameters
     */
    comunicazioneConsegnaVoucher(requestParameters: ComunicazioneConsegnaVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherConsegnaComunicazioneDTO>;

    /**
     * Consegna i voucher (ASSEGNATO→DA_CONSUMARE) + comunicazione cittadino (bando → VOUCHER_CONSEGNATI)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/consegna
* @param requestParameters
     */
    consegnaVoucher(requestParameters: ConsegnaVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherConsegnaSummaryDTO>;

    /**
     * Dettaglio di un voucher del bando
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}
* @param requestParameters
     */
    dettaglioVoucher(requestParameters: DettaglioVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherDTO>;

    /**
     * Download del PDF+QR di un voucher del bando
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/pdf
* @param requestParameters
     */
    downloadVoucherPdf(requestParameters: DownloadVoucherPdfRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Emette i voucher dalle righe graduatoria finanziate (bando → VOUCHER_ASSEGNATI)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/genera
* @param requestParameters
     */
    generaVoucher(requestParameters: GeneraVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherEmissioneSummaryDTO>;

    /**
     * Lista dei voucher del bando (vista backoffice completa)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher
* @param requestParameters
     */
    listaVoucher(requestParameters: ListaVoucherRequestParams, extraHttpRequestParams?: any): Observable<Array<VoucherDTO>>;

    /**
     * Proroga la scadenza di un voucher del bando (GIORNI o DATA)
     * Forma GIORNI: +N giorni alla scadenza attuale; forma DATA: nuova scadenza unica (fine giornata). Solo in avanti; voucher con credito residuo (ASSEGNATO, DA_CONSUMARE, PARZIALMENTE_CONSUMATO), anche se gia\&#39; scaduti. Motivo obbligatorio e version del voucher (stale -&gt; 409 con residuo e version correnti). Dopo la proroga il PDF viene rigenerato e parte l\&#39;evento VOUCHER_PROROGATO. SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/proroga
* @param requestParameters
     */
    prorogaVoucher(requestParameters: ProrogaVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherDTO>;

    /**
     * Proroga la scadenza di tutti i voucher prorogabili del bando
     * Stesse regole della proroga del singolo voucher, applicate a tutti i voucher con credito residuo del bando. I voucher gia\&#39; oltre la data (o senza scadenza con forma GIORNI) restano invariati e sono contati in \&#39;saltati\&#39;. Su un bando con scadenza a data fissa aggiorna anche la data della policy. Motivo obbligatorio.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/proroga
* @param requestParameters
     */
    prorogaVoucherBando(requestParameters: ProrogaVoucherBandoRequestParams, extraHttpRequestParams?: any): Observable<VoucherProrogaEsitoDTO>;

    /**
     * Revoca un voucher del bando (ANNULLATO) secondo la modalita\&#39; di revoca della policy
     * Richiede la revoca abilitata sul bando (revoca_voucher_modalita), un motivo non vuoto e la version del voucher (stale -&gt; 409 con residuo e version correnti). Modalita\&#39;: SOLO_NON_SPESO (rifiuta se c\&#39;e\&#39; importo speso), BLOCCA_E_REGISTRA (registra l\&#39;importo da recuperare), BLOCCA_E_STORNA (annulla i consumi se non ancora rendicontati). Dopo la revoca parte l\&#39;evento VOUCHER_REVOCATO (non per i voucher ASSEGNATO). SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/revoca
* @param requestParameters
     */
    revocaVoucher(requestParameters: RevocaVoucherRequestParams, extraHttpRequestParams?: any): Observable<VoucherDTO>;

}
